module.exports = __webpack_public_path__ + "static/media/logo.cf27b2cc.png";